import { useSelector } from 'react-redux';
import { ComponentContainer } from '@styles/layout';
import { getRecentlyViewed, RecentlyViewedItem } from '@state/recently-viewed';
import { RecentlyViewed } from '@components/recently-viewed';

export const RecentlyViewedContainer = () => {
  const recentlyViewed: Array<RecentlyViewedItem> = useSelector(getRecentlyViewed);
  return (
    <ComponentContainer>
      <RecentlyViewed title={'recently-viewed__header--label'} recentlyViewed={recentlyViewed} />
    </ComponentContainer>
  );
};
